var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:home-09",
    clipPath: "url(#clip0_1994_1095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9534 10.9534L10.9534 18.3309C10.9534 18.607 10.8468 18.8516 10.6335 19.0649C10.4202 19.2782 10.1755 19.3849 9.89949 19.3849C9.62346 19.3849 9.3788 19.2782 9.1655 19.0649C8.95221 18.8516 8.84556 18.607 8.84556 18.3309L8.84556 10.9534L1.46799 10.9534C1.19195 10.9534 0.94729 10.8467 0.733993 10.6334C0.520696 10.4201 0.414047 10.1754 0.414047 9.89941C0.414047 9.62338 0.520696 9.37872 0.733993 9.16542C0.94729 8.95212 1.19195 8.84548 1.46799 8.84548L8.84556 8.84548L8.84556 1.4679C8.84556 1.19187 8.95221 0.947208 9.1655 0.733912C9.3788 0.520614 9.62346 0.413967 9.89949 0.413967C10.1755 0.413967 10.4202 0.520614 10.6335 0.733911C10.8468 0.947208 10.9534 1.19187 10.9534 1.46791L10.9534 8.84548L18.331 8.84548C18.607 8.84548 18.8517 8.95212 19.065 9.16542C19.2783 9.37872 19.3849 9.62338 19.3849 9.89941C19.3849 10.1754 19.2783 10.4201 19.065 10.6334C18.8517 10.8467 18.607 10.9534 18.331 10.9534L10.9534 10.9534Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1994_1095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhite);
export default __webpack_public_path__ + "static/media/plus_white.d1ca5b4ba5453c0a5ab44b1a9c39d433.svg";
export { ForwardRef as ReactComponent };